const blankToNull = require('./../../../utils').blankToNull;

export function validate(record){
    blankToNull(record);
    const errors = [];
    if (!record.nomePerfil || record.nomePerfil.trim().length < 3) {
        errors.push({ field: 'nome', message: 'O campo nome é obrigatório e deve ter mais de 3 caracteres' });
    }
    
    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}